<template>
    <rkm-modal
        :buttons="['cancel']"
        large
        ref="RkmModal"
        title="Detalhamento do agendamento"
        v-if="pacienteExists"
    >
        <rkm-alert show info>
            <p>
                <strong>{{ data.form.paciente.cidadao.nome }}</strong>
            </p>
            <p>
                <strong>Idade:</strong>
                    <template v-if="data.form.paciente.cidadao.idade">
                    {{ data.form.paciente.cidadao.idade.anos }} anos,
                    {{ data.form.paciente.cidadao.idade.meses }} meses e
                    {{ data.form.paciente.cidadao.idade.dias }} dias
                    </template>
                <template v-else>
                -
                </template> -
                <strong>Prontuário: </strong>{{ data.form.paciente.prontuario }}
            </p>

        </rkm-alert>

        <rkm-row>
            <rkm-col>
                <table class="table table-striped">
                    <tbody>
                        <tr>
                            <td><strong>Agendamento:</strong></td>
                            <td>{{agendamento.agendamentoNumero}}</td>
                        </tr>
                        <tr v-if="agendamento.urgente == true">
                            <td><strong>Urgente</strong></td>
                            <td>Sim</td>
                        </tr>
                        <tr v-else>
                            <td><strong>Urgente</strong></td>
                            <td>Não</td>
                        </tr>
                        <tr>
                            <td><strong>Data do agendamento:</strong></td>
                            <td>{{agendamento.data}} ás {{agendamento.horaExame}}</td>
                        </tr>
                        <tr>
                            <td><strong>Grupo de exame:</strong></td>
                            <td>{{agendamento.grupoExameNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Exame(s) incluído(s):</strong></td>
                            <td> {{examesIncluido()}} </td>
                        </tr>
                        <tr>
                            <td><strong>Médico solicitante:</strong> </td>
                            <td>{{agendamento.medicoNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Profissional executante:</strong></td>
                            <td>{{agendamento.profissionalNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Unidade executante:</strong> </td>
                            <td>{{agendamento.unidadeNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Local de atendimento:</strong></td>
                            <td>{{agendamento.infraestruturaNome}}</td>
                        </tr>
                        <tr>
                            <td><strong>Observação:</strong></td>
                            <td>{{agendamento.observacao}}</td>
                        </tr>
                    </tbody>
                </table>
            </rkm-col>
        </rkm-row>
    </rkm-modal>
</template>

<script>

// Mixins.
import { error, repository } from '@/mixins'

// Moment.
import moment from 'moment'

//Enums
import diasSemana from '@/enums/exame-imagem/diasSemana'

export default {
    computed: {
        pacienteExists() {
            return this.data.form && this.data.form.paciente
        },
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamentoRetroativo')
        }
    },
    data: () => ({
        items: [],
        exames:[],
        agendamento: {
            agendamentoNumero: null,
            data: null,
            grupoExameId: null,
            grupoExameNome: '',
            horaExame: '',
            urgente: false,
            infraestruturaId: null,
            infraestruturaNome: '',
            profissionalId: null,
            profissionalNome: '',
            diasSemana:null,
            semanaId: null,
            unidadeId: null,
            unidadeNome: '',
            observacao: '',
            incluido: [],
            medicoNome: '',
            medicoId: '',
        },
        enums: {
            diasSemana
        },
    }),
    methods: {
        examesIncluido(){

            let nomeExames = ''

            if (this.agendamento.incluido) {

                this.agendamento.incluido.forEach(exameNomeIncluido => {

                    if(!nomeExames){

                        nomeExames = exameNomeIncluido.nome
                    } else {

                        nomeExames = nomeExames + ', ' + exameNomeIncluido.nome
                    }
                })
            }

            return nomeExames
        },
        open(item) {

            var data = moment(item.data, 'DD/MM/YYYY').toDate()
            var dia = data.getDay() + 1;

            if(dia == this.enums.diasSemana.DOMINGO){
                this.agendamento.diasSemana = 'DOMINGO'

            } else if (dia == this.enums.diasSemana.SEGUNDA_FEIRA){
                this.agendamento.diasSemana = 'SEGUNDA-FEIRA'

            } else if (dia == this.enums.diasSemana.TERCA_FEIRA){
                this.agendamento.diasSemana = 'TERÇA-FEIRA'

            } else if (dia == this.enums.diasSemana.QUARTA_FEIRA){
                this.agendamento.diasSemana = 'QUARTA-FEIRA'

            } else if (dia == this.enums.diasSemana.QUINTA_FEIRA){
                this.agendamento.diasSemana = 'QUINTA-FEIRA'

            } else if (dia == this.enums.diasSemana.SEXTA_FEIRA){
                this.agendamento.diasSemana = 'SEXTA-FEIRA'

            } else if (dia == this.enums.diasSemana.SABADO){
                this.agendamento.diasSemana = 'SÁBADO'
            }

            this.agendamento.data = item.data.split("-").reverse().join("/")
            this.agendamento.grupoExameNome = item.grupoExameNome
            this.agendamento.agendamentoNumero = item.agendamentoNumero
            this.agendamento.urgente = item.urgente
            this.agendamento.horaExame = item.horaExame
            this.agendamento.incluido = item.incluido
            this.agendamento.medicoNome = item.medicoNome
            this.agendamento.unidadeNome = item.unidadeNome
            this.agendamento.infraestruturaNome = item.infraestruturaNome
            this.agendamento.profissionalId = item.profissionalId
            this.agendamento.profissionalNome = item.profissionalNome
            this.agendamento.observacao = item.observacao

            this.items = []
            this.$refs.RkmModal.show()
        },
    },
    mixins: [ error, repository ],
    props: {
        data: { type: Object, required: true },
    },
}
</script>

<style scoped>
p {
    margin: 0px;
}
</style>